<template>
  <div class="dataGridSettings__row">
    <div class="dataGridSettings__name">
      {{ title }}
    </div>
    <div class="dataGridSettings__value">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: ['title']
}
</script>
